import { inviteAdminApi } from '@/services/inviteAdminApi';
import { InviteAdminStore } from './invite-admin-store';

export const inviteAdminStore = new InviteAdminStore(inviteAdminApi);
